import { INiche } from "services/types";
import { CheckButton } from "components/buttons";
import { Image } from "components";

import "./NicheSelector.scss";
import { useCallback, useMemo } from "react";
import { getFilteredNiches, updateSelectedNiches } from "./utils";

interface IProps {
  niches: INiche[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export const NicheSelector = ({ niches, selected, onChange }: IProps): JSX.Element => {
  const orderedNiches = useMemo(
    () => getFilteredNiches(niches, selected),
    [niches, selected]
  );

  const handleClick = useCallback((id: string) => () => {
    onChange(updateSelectedNiches(id, selected));
  }, [onChange, selected]);

  return (
    <div className="nicheSelector">
      {orderedNiches.map((el: INiche, index: number) => (
        <div className="row" key={index}>
          <Image src={el.thumbnail} />

          <div className="name">{el.name}</div>

          <CheckButton
            onClick={handleClick(el.id)}
            checked={selected.indexOf(el.id) >= 0}
          />
        </div>
      ))}
    </div>
  );
};
